import React, { Component } from 'react';
import './Projects.css';

export default class Projects extends Component {

  componentDidMount(){
    this.props.heightUpdate(this.divElement.clientHeight);
  }

  render() {
    return (
      <div id="projects-container" className="projects-container" ref={divElement => this.divElement = divElement} > 
        <h1 className="projects-title">PROJECTS</h1>
        <div className='projects-section'>
          <Project 
            projectName='Zero Hunger'
            projectDesc='Big data project that found the crops most correlated with GDP for various low income African countries'
            projectGithub="https://github.com/aliang6/cse545_final_project"
            //projectWebsite="https://aliang6.github.io/cse545_final_project/"
            projectSpark={true}
          />
          <Project 
            projectName='Gerry'
            projectDesc='Web application that redistricts voting districts of US states based off various fairness metrics'
            projectGithub="https://github.com/devhid/gerry-backend"
            projectWebsite="https://gerryapp.netlify.app/"
            projectSpring={true}
          />
          <Project 
            projectName='E-Commerce System'
            projectDesc='Normalized database system supporting various SQL transactions'
            projectGithub="https://github.com/aliang6/cse305"
            projectMysql={true}
          />
          <Project
            projectName='Credit Data Visualization'
            projectDesc='Data visualization of customer credit attributes'
            // projectGithub="../cse564/"
            projectWebsite="https://credit-data-visualization.netlify.app/"
            // projectWebsite="/credit-visualization"
            projectD3={true}
          />
          <Project 
            projectName='Prestige'
            projectDesc='Application to determine website reputation and writer trustworthiness through an article'
            projectGithub="https://github.com/aliang6/Prestige/"
            //projectWebsite="https://prestige-web-app.herokuapp.com/"
            projectReact={true}
          />
          {/* <Project 
            projectName='Mirage'
            projectDesc='Conversational chatbot in a minimalistic mobile app'
            projectGithub="https://github.com/aliang6/Mirage/"
            projectReact={true}
          /> */}
          </div>
          <div className='projects-section'>
          <Project 
            projectName='MarketMe'
            projectDesc='Web application designed to aid integration into communities one intends to market to'
            projectGithub="https://github.com/aliang6/MarketMe/"
            //projectWebsite="https://market-me.herokuapp.com/"
            projectNode={true}
          />
          <Project 
            projectName='GitSearch'
            projectDesc='Search engine for open-source projects on GitHub'
            projectGithub="https://github.com/aliang6/GitSearch/"
            projectWebsite="https://gitsearch-web-app.herokuapp.com/"
            projectNode={true}
          />
          <Project 
            projectName='Chinese Chess'
            projectDesc='Java/JavaFX application for the traditional board game of Chinese Chess'
            projectGithub="https://github.com/aliang6/Chinese-Chess/"
            projectJava={true}
          />
          <Project 
            projectName='C Projects'
            projectDesc='Compilation of projects created in C' // such as a multi-threaded server that stores key-value pairs'
            projectGithub="https://github.com/aliang6/cse320/"
            projectC={true}
          />
          <Project 
            projectName='Assembly Projects'
            projectDesc='Compilation of projects created in MIPS Assembly' //such as a recursive search for DNA sequence patterns'
            projectGithub="https://github.com/aliang6/cse220/"
            projectAssembly={true}
          />
        </div>
    </div>
    );
  }
}

class Project extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
    }
    
    this.mouseHover = this.mouseHover.bind(this);
    this.mouseExit = this.mouseExit.bind(this);
  }

  
  mouseHover(event) {
    event.preventDefault();
    this.setState({
      hovered: true,
    });
  }

  mouseExit(event) {
    event.preventDefault();
    this.setState({
      hovered: false,
    });
  }


  render() {
    return (
      <div className={'project-container ' + 
        (this.props.projectReact ? 'react-logo' : '') + 
        (this.props.projectNode ? 'nodejs-logo' : '') + 
        (this.props.projectJava ? 'java-logo' : '') + 
        (this.props.projectC ? 'c-logo' : '') + 
        (this.props.projectAssembly ? 'asm-logo' : '') + 
        (this.props.projectSpark ? 'spark-logo' : '') + 
        (this.props.projectSpring ? 'spring-logo' : '') + 
        (this.props.projectMysql ? 'mysql-logo' : '') +
        (this.props.projectD3 ? 'd3-logo' : '')} >
        <div className='project-overlay'>
          <h2 className='project-name'>{this.props.projectName}</h2>
          <div className='project-hover'>
          <h2 className='project-desc'>{this.props.projectDesc}</h2>
          <div className='project-links'>
            {this.props.projectGithub && <div className='project-github'><a href={this.props.projectGithub} target="_blank" rel="noopener noreferrer">GitHub</a></div>}
            {this.props.projectWebsite && <a href={this.props.projectWebsite} className='project-website' target="_blank" rel="noopener noreferrer">Website</a>}
          </div>
          {/* {this.state.hovered && <h2 onMouseEnter={this.mouseHover} onMouseOver={this.mouseHover} onMouseLeave={this.mouseExit} className='project-desc'>{this.props.projectDesc}</h2>}
          {!this.state.hovered && <h2 className='project-name'>{this.props.projectName}</h2>} */}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Projects/Projects.js